var data = { header:{ text:"#### This test is pending New York state approval and is not available to be ordered at this time",
    closeButton:true },
  buttons:[ { text:"OK",
      isPrimary:true } ] };
data.header;
data.buttons;

export { data as default };
//# sourceMappingURL=missing_ny_approval.esm.js.map
